import {ReportItem, ReportRow} from './ReportTypes';
import {REPORT_ACCESS} from './Constants';
import {reportTypeLabelId} from './reportTypeLabel';

const getReportDate = (date: string | null): Date | null => {
	return date ? new Date(date) : null;
};

export const mapReportToRow = (
	report: ReportItem,
	personId: string | null,
	formatMessage: (descriptor: {id: string}) => string,
	builderEnabled: boolean
): ReportRow => {
	const isShared = !!report.shares?.edges?.length;
	// A share held by the viewer themselves, which is what decides whether a private report can be
	// reached at all. Distinct from isShared, which says the report has been shared with someone: the
	// share list is only readable by an owner, an editor or an admin unless the reports redesign is on,
	// so isShared can be false on the very rows that reached the viewer through a share.
	const isSharedWithViewer = !!report.sharedWithViewer;
	// Types that keep the name they already have get no key back, and fall through to the stored
	// value -- which is what the column rendered before this, so they are left exactly as they were.
	const typeLabelId = reportTypeLabelId(report.type, report.source, builderEnabled);
	return {
		...report,
		lastViewed: getReportDate(report.lastViewed),
		updatedAt: getReportDate(report.updatedAt),
		typeLabel: typeLabelId ? formatMessage({id: typeLabelId}) : report.type ?? '',
		isShared: isShared,
		isSharedWithViewer: isSharedWithViewer,
		isReportOwner: report.person?.id === personId,
		favorite: !!report.favorite,
		privateAccess: !!report.privateAccess,
		access:
			isShared || isSharedWithViewer
				? REPORT_ACCESS.SHARED
				: !report.privateAccess
				? REPORT_ACCESS.COMPANY
				: REPORT_ACCESS.PRIVATE,
	};
};
